import { BillingTier } from "types/generated";

import { V5_TIERS_SEQUENCE } from "../constants";
import { UPGRADE_MARKETING_TIERS } from "./constants";

// Places any tier on the V5 ladder: V4 -> its V5 counterpart, the folded Starter + 2 -> Starter +; every
// other V5 tier is itself; legacy/V3 tiers have no place on the ladder.
const V5_LADDER_EQUIVALENT: Partial<Record<BillingTier, BillingTier>> = {
  [BillingTier.V4Free]: BillingTier.V5Free,
  [BillingTier.V4Starter]: BillingTier.V5Starter,
  [BillingTier.V4StarterPlus]: BillingTier.V5StarterPlus,
  [BillingTier.V4Business]: BillingTier.V5Business,
  [BillingTier.V4Enterprise]: BillingTier.V5Enterprise,
  [BillingTier.V5StarterPlus_2]: BillingTier.V5StarterPlus,
};

const toLadderTier = (tier: BillingTier): BillingTier | undefined =>
  V5_LADDER_EQUIVALENT[tier] ?? (V5_TIERS_SEQUENCE.includes(tier) ? tier : undefined);

// Free sits below Starter on the ladder used for the cards' "All from ..." header.
const UPGRADE_LADDER_WITH_FREE = [BillingTier.V5Free, ...UPGRADE_MARKETING_TIERS];

// Marketing cards strictly above the account's position; empty for the top tiers and legacy/V3.
export const getUpgradeTiers = (tier: BillingTier): BillingTier[] => {
  const current = toLadderTier(tier);
  if (!current) return [];

  const position = V5_TIERS_SEQUENCE.indexOf(current);

  return UPGRADE_MARKETING_TIERS.filter(
    (marketingTier) => V5_TIERS_SEQUENCE.indexOf(marketingTier) > position
  );
};

export const getPreviousBillingTier = (tier: BillingTier): BillingTier | undefined => {
  const current = toLadderTier(tier);
  if (!current) return undefined;

  const index = UPGRADE_LADDER_WITH_FREE.indexOf(current);
  if (index <= 0) return undefined;

  return UPGRADE_LADDER_WITH_FREE[index - 1];
};
